import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { Fragment } from 'react'
import Box from 'src/components/Box/Box'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface NotesBoxProps {
  className?: string
  notes?: string
  backgroundColor?: string
  copy: React.ReactElement
}

const NotesBox: React.FC<NotesBoxProps> = (props): React.ReactElement => {
  const noNotesImage = useColorOrGrayscaleImage(ImageNames.NoNotes)
  return (
    <Box
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        background-color: ${props.backgroundColor
          ? props.backgroundColor
          : styleConstants.colors.gray_lightest};
      `}
    >
      {props.notes !== undefined && (
        <Fragment>
          <span
            css={css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
            `}
          >
            <Trns source={'Notes'} />
          </span>
          <span
            data-testid={'notes'}
            css={css`
              margin-top: 30px;
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
              white-space: pre-wrap;
              overflow: auto;
            `}
          >
            {props.notes}
          </span>
        </Fragment>
      )}
      {(props.notes === undefined || props.notes === '') && (
        <Fragment>
          <img
            src={noNotesImage}
            css={css`
              height: 75px;
            `}
            alt={''}
          />
          <span
            data-testid={'noNotes'}
            css={css`
              margin-top: 30px;
              text-align: center;
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
            `}
          >
            <Trns source={'Nothing to note'} />
          </span>
          <span
            css={css`
              margin-top: 30px;
              text-align: center;
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
            `}
          >
            {props.copy}
          </span>
        </Fragment>
      )}
    </Box>
  )
}

export default NotesBox
